import { useMsal } from "@azure/msal-react";


export const AccessToken = () => {    
    
    const { instance, accounts } = useMsal();
    
    const accessTokenRequest:any = {
        scopes: ["api://a78f5d2a-b382-4d41-99eb-89f92d896a9b/user_auth"],
        account: accounts[0],
    };
    
    //BRT PROD
    //const accessTokenRequest:any = {
    //    scopes: ["api://416d379a-7413-4ee3-adf4-cbd6e47b7d55/user_impersonation"],
    //    account: accounts[0],
    //};
    
    return [instance, accessTokenRequest]
}
